/*
*@/components/common/country-selector/country-selector
*/
export default {
  CountrySelector: {
    script: {
      placeholder: 'Select Country',
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/buyer/cat4mro/components/countrySelector.js